import { post } from "./methods";

const testFromHere = ({ id, ...rest }) =>
  post(`/api/frontend/bots/${id}/start-flow/`)({ data: { ...rest } });

const getConversation = ({ id, ...rest }) =>
  post(`/api/frontend/botusers/${id}/conversations/`)({ data: { ...rest } });

export default {
  testFromHere,
  getConversation,
};
